import React from "react";
import styled from "styled-components";
import EmojiPenaltyNote from "../shared/EmojiPenaltyNote";
import type { EmojiPenaltyResponse } from "../../api/types";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * Redacted not_started view (no countdown, no banner) shown when the
 * backend hides today's `scheduledTime` due to an active `hidden_shift`
 * card from another user. Mirrors monolith lines 1328–1336.
 */
export const NotStartedHiddenState: React.FC<{ emojiPenalty?: EmojiPenaltyResponse }> = ({
  emojiPenalty,
}) => (
  <SignupMessage
    style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}
  >
    <div>
      <p>Today&apos;s Art of the Day will drop later. Check back later.</p>
    </div>
    <EmojiPenaltyNote penalty={emojiPenalty} moment="upcoming" />
  </SignupMessage>
);

export default NotStartedHiddenState;
